import Vue from 'vue';
import { uiSettings } from '@/tools/ui/uiSettings';

export const _ui: typeof uiSettings = uiSettings;
Object.freeze(_ui);
Vue.prototype.$ui = _ui;



// WEBPACK FOOTER //
// ./src/tools/declare/global/$ui.ts